
<template>
  <b-modal ref="modal" hide-footer title="Change Status">

        <div class="label">Transfer Callback</div>
        <div class="text">{{ companyId }}</div>
        <div class="text text-right">
          <b-button class="mt-3" variant="danger" @click="hideModal">
            <font-awesome-icon icon="times" /> Cancel
          </b-button>

          <b-button class="mt-3" variant="success" @click="createTransfer">
            <font-awesome-icon icon="check" /> Confirm
          </b-button>
        </div>
  </b-modal>
</template>

<script>

import DataSelectionService from "@/services/DataSelection.service";

export default {
  name: "CompanyTransferCreateModal",
  props: {
    companyId: Number,
  },

  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    createTransfer() {

      this.$http.post("/company/createtransfer/" + this.companyId).then(() => {



          if (this.$route.name == "CompanyCall") {
            DataSelectionService.getNextCompany().then((result) => {
              if (result && result.data != 0) {
                this.$router.push("/call/" + result.data);
              } else {
                this.$router.push("/getnext");
              }
            });
          } else {
            this.hideModal();
          }


      });
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: 600;
}
.text {
  margin-bottom: 10px;
}
</style>
